<template>
  <transition name='modal'>
    <div v-if='show' class='modal-mask ct-flex-center'>
      <div class='modal-container' @click.stop>
        <slot/>
      </div>
    </div>
  </transition>
</template>

<script>
export default {

  name: 'Modal',

  props: {
    show: Boolean
  },
  mounted: function () {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.close()
      }
    })
  }
}
</script>
